import * as React from 'react'
import * as PropTypes from 'prop-types'
import styled from 'styled-components'

import ActionButton from '../../ui/ActionButton/ActionButton'

import PreferenceItem from '../PreferenceItem/PreferenceItem'

const ButtonWrapper = styled.div`
  margin: 1rem 0;
`

const BlockButton = styled(ActionButton)`
  width: 100%;
`

const StyledPreferenceItem = styled(PreferenceItem)`
  margin: 5px;
`

const PreferenceWrapper = styled.div`
  flex-wrap: wrap;
  display: flex;
  justify-content: center;
`

const StyledParagraph = styled.p`
  font-size: 0.875rem;
  line-height: 1.3125rem;
  margin: 0;
  margin-bottom: 2.8125rem;
  text-align: center;
`

const ValidMessage = styled(StyledParagraph)`
  margin: 2.75rem 0;
`

function hasSelected(preferences) {
  const selectCount = preferences.filter(pref => pref).length

  return {
    isSelected: !!selectCount,
    selectCount,
  }
}

function PreferenceForm(props) {
  const {
    handleSubmit,
    handleChange,
    values,
    isSubmitting,
    isValid,
    disabled,
    method,
    action,
    basePreferences = [],
    buttonLabel,
  } = props

  const { preferences } = values || {}

  const { isSelected, selectCount } = hasSelected(preferences || [])
  const enableSelect = selectCount < 4

  return (
    <form onSubmit={handleSubmit} method={method} action={action}>
      <fieldset disabled={isSubmitting || disabled}>
        <StyledParagraph>
          Set up your content preferences by selecting up to 4 topics that
          interest you
        </StyledParagraph>
        <PreferenceWrapper>
          {basePreferences.map(itemData => (
            <StyledPreferenceItem
              name={`preferences[${itemData.id}]`}
              selected={preferences ? preferences[itemData.id] : false}
              value={itemData.id}
              itemData={itemData}
              key={itemData.id}
              enableSelect={enableSelect}
              onChange={handleChange}
            />
          ))}
        </PreferenceWrapper>
        {isSelected > 0 && (
          <ValidMessage>
            All good! Press "{buttonLabel || 'Next'}" to continue
          </ValidMessage>
        )}
        <ButtonWrapper>
          <BlockButton type="submit" variant="primary" disabled={!isValid}>
            {buttonLabel || 'Next'}
          </BlockButton>
        </ButtonWrapper>
      </fieldset>
    </form>
  )
}

PreferenceForm.defaultProps = {
  handleSubmit: null,
  handleChange: null,
  handleBlur: null,
  values: {},
  errors: {},
  touched: {},
  isSubmitting: false,
  isValid: false,
  disabled: false,
  method: 'get',
  action: '',
}

PreferenceForm.propTypes = {
  handleSubmit: PropTypes.func,
  handleChange: PropTypes.func,
  handleBlur: PropTypes.func,
  values: PropTypes.shape(),
  errors: PropTypes.shape(),
  touched: PropTypes.shape(),
  isSubmitting: PropTypes.bool,
  isValid: PropTypes.bool,
  disabled: PropTypes.bool,
  method: PropTypes.oneOf(['get', 'post']),
  action: PropTypes.string,
}

export default PreferenceForm
